<template>
  <v-container style="flex: 0 0;" class="pa-0">
    <v-data-table class="ingestion-results-changes five-items" :headers="headers" disable-initial-sort :items="trackedChanges" :rows-per-page-items="[5]" no-data-text="There are no changes in your data.">
      <template v-slot:headers="props">
        <tr>
          <th v-for="(header, index) in props.headers" :key="`header-${index}`" :style="`text-align: ${header.align}`" :class="[`pl-${ index == 0 ? '4' : '2' } pr-2`]">{{ header.text }}</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <template v-if="props.item.type == changeTypes.dirty">
            <td class="pl-4 pr-2">
              <v-btn class="ma-0" @click="setSelected(props.item.location)" small>{{ props.item.displayName }}</v-btn>
            </td>
            <td class="px-2">
              <v-input class="teal--text text--darken-3 dirtyInput" :messages="[props.item.initialValue || 'blank']">
                <template slot="prepend">
                  <v-icon class="icon-shadow" :color="getStatus(props.item).color">edit</v-icon>
                </template>
                {{ props.item.value }}
              </v-input>
            </td>
          </template>
          <template v-else>
            <td class="pl-4 pr-2">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ma-0" @click="setSelected(props.item.location)" small>{{ props.item.displayName }}</v-btn>
                </template>
                <span>{{ props.item.fullName }}</span>
              </v-tooltip>
            </td>
            <td class="px-2">
              <v-input hide-details class="dirtyRow">
                <template slot="prepend">
                  <v-icon class="icon-shadow" :color="props.item.iconColor">{{ props.item.icon }}</v-icon>
                </template>
                {{ props.item.text }}
              </v-input>
            </td>
          </template>
          <td class="px-2">
            <v-btn v-if="props.item.canUndo" small class="ma-0 pa-0 undo-change" @click="props.item.undo()" color="secondary lighten-1">
              <v-icon>undo</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const ingestionResults = createNamespacedHelpers('reviewingestionresults')
  const CHANGE_TYPES = {
    newRowAbove: {
      type: 1,
      text: 'New row',
      icon: 'star',
      iconColor: 'info lighten-2',
      canUndo: false,
    },
    deletedRow: {
      type: 2,
      text: 'Deleted row',
      icon: 'remove',
      iconColor: 'red lighten-2',
      canUndo: true,
    },
  }

  export default {
    data: () => ({
      headers: [{
        text: 'Location',
        value: 'location',
        sortable: false,
        align: 'left',
      },
      {
        text: 'Change',
        value: 'value',
        sortable: false,
        align: 'left',
      },
      {
        text: 'Undo',
        value: 'value',
        sortable: false,
        align: 'left',
      },
      ],
      changeTypes: {
        'dirty': 0,
        'newRowAbove': 1,
        'deletedRow': 2,
      },
    }),
    computed: {
      ...ingestionResults.mapGetters(['logs', 'locationPrinter',
        'locator', 'getMetadata', 'getChanges', 'getMetadatumLocation', 'metadataResetter', 'logsMeta', 'undoChange',
      ]),
      dirtyData() {
        let indexes = Object.keys(this.$store.getters['reviewingestionresults/dirtyData'])
        let dirtyData = []

        indexes.forEach(index => {
          dirtyData.push(this.locator(index))
        })

        return dirtyData
      },
      trackedChanges() {
        let trackedChanges = []

        let locationName
        this.dirtyData.forEach(datum => {
          console.log(datum.location)
          datum.type = this.changeTypes.dirty

          locationName = this.locationPrinter(datum.location)
          datum.displayName = locationName.displayName
          datum.fullName = locationName.fullName
          datum.undo = () => this.undo(datum)
          datum.canUndo = true
          trackedChanges.push(datum)
        })

        let changes = this.getChanges
        for (const change of changes) {
          let trackedChange = {
            ...change,
            ...CHANGE_TYPES[change.changeType],
            undo: () => this.undoChange(change),
          }
          trackedChanges.push(trackedChange)
        }

        return trackedChanges
      },
    },
    methods: {
      undo(item) {
        if (item.type == this.changeTypes.dirty) {
          this.$store.dispatch('reviewingestionresults/resetDirtyDatum', [item.location])
        } else {
          this.metadataResetter(item.location)
        }
      },
      setSelected(location) {
        console.log('setSelected location', location)
        this.$store.dispatch('reviewingestionresults/setSelectedLocation', location)
        this.$store.dispatch('reviewingestionresults/goToLocation', location)
      },
      getStatus(log) {
        let metadatum = this.getMetadatumLocation(log.location)
        let defaultColor = 'teal'
        if (metadatum && metadatum.isDeleted) {
          return {
            icon: 'close',
            color: defaultColor,
          }
        }

        if (this.dirtyData[log.location]) {
          return {
            icon: 'edit',
            color: defaultColor,
          }
        }

        if (log.ignore) {
          return {
            icon: 'notifications_paused',
            color: defaultColor,
          }
        }

        return {
          icon: log.severity,
          color: defaultColor,
        }
      },
    },
  }
</script>

<style>
  .dirtyInput>.v-input__control>.v-input__slot {
    margin-bottom: 0px;
  }

  .dirtyRow>.v-input__prepend-outer,
  .dirtyRow>.v-input__append-outer {
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>
<style scoped>
  .ingestion-results-changes {
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
  }

  .undo-change.v-btn {
    min-width: 36px;
  }
</style>